<script>

import { useHead } from '@vueuse/head'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import appConfig from '@src/app.config'
import NavBar from '@components/nav-bar.vue'
import Footer from '@components/footer.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'

export default {
  name: 'App',
  components: { NavBar, Loading, Footer },
  setup() {
    const store = useStore()
    const route = useRoute()

    const loadingRef = ref(null)

    useHead({
      titleTemplate: (title) =>
        title ? title : appConfig.title,
    })
    useHead(() => ({
      meta: [
        window.innerWidth > 767 && window.innerWidth < 1022
          ? {
              name: 'viewport',
              content:
                'width=1022,maximum-scale=1,user-scalable=no',
            }
          : {},
      ],
    }))

    const includes = computed(
      () => store.state.layout.keepAliveIncludes
    )
    const couponPage = computed(() => {
      if(route.path && route.path.indexOf('coupon-list') > 0){
        return true;
      }
      return false;
    })
    onMounted(() => {
      loadingRef.value.$el.removeAttribute('tabindex')
    })
    onUnmounted(() => {
      window.onresize = null
    })
    const focusIn = () => {
      if (
        /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) &&
        store.state.layout.focusHideEnable
      ) {
      }
    }
    const focusOut = () => {
      if (
        /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) &&
        store.state.layout.focusHideEnable
      ) {
      }
    }
    return {
      loadingRef,
      includes,
      couponPage,
      focusIn,
      focusOut,
    }
  },
}
</script>
<template>
  <div id="app" @focusin="focusIn" @focusout="focusOut">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <!-- <RouterView v-if="!$route.meta.keepAlive" :key="$route.fullPath" /> -->
    <NavBar v-if="!couponPage"/>
    <RouterView v-slot="{ Component }">
      <keep-alive :include="includes">
        <component
          :is="Component"
          :key="$route.name"
        />
      </keep-alive>
    </RouterView>
    <Loading
      ref="loadingRef"
      :active="$store.state.layout.isLoading"
      color="#070141"
      loader="bars"
      :opacity="0.9"
      :can-cancel="true"
    ></Loading>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
// @import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
// @import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
// @import '@design';

*,
*::before,
*::after {
  // box-sizing: border-box;
}

* {
  -webkit-overflow-scrolling: touch;
}

#app {
  height: 100%;
  word-break: break-all;
}

@media screen and (min-width: 768px) {
  #app {
    min-height: 500px;
  }
}

// ===
// Base element styles
// ===
fieldset,
img {
  vertical-align: bottom;
  pointer-events: none;
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
  border: 0;
  -webkit-touch-callout: none;
}
</style>
